import { api } from "../config/api-config";

export const userLogin = async (data) => {
  const response = await api.post("/auth/login", data, {
    requiresAuth: false,
  });
  return response.data;
};

export const userSignUp = async (data) => {
  const response = await api.post("/auth/user/signup", data, {
    requiresAuth: false,
  });
  return response.data;
};
export const VerifyOTP = async (data) => {
  const response = await api.post("/auth/verify-email", data, {
    requiresAuth: true,
  });
  return response.data;
};
export const VerifyOTPNoAuth = async (data) => {
  const response = await api.post("/auth/verify-otp", data, {
    requiresAuth: false,
  });
  return response.data;
};

export const resendOTP = async () => {
  const response = await api.post(
    "/auth/resend-otp",
    {},
    {
      requiresAuth: true,
    },
  );
  return response.data;
};

export const forgotPassword = async (data) => {
  const response = await api.post("/auth/forgot-password", data, {
    requiresAuth: false,
  });
  return response.data;
};

export const resetPassword = async (data) => {
  const response = await api.post("/auth/reset-password", data, {
    requiresAuth: false,
  });
  return response.data;
};

export const userLogout = async () => {
  const response = await api.post(
    "/auth/logout",
    {},
    {
      requiresAuth: true,
    },
  );
  return response.data;
};

export const registerAdmin = async () => {
  const response = await api.post(
    "/auth/registerAdmin",
    {},
    {
      requiresAuth: false,
    },
  );
  return response.data;
};

export const vendorSignUp = async (data) => {
  const response = await api.post("/auth/vendor/signup", data, {
    requiresAuth: false,
  });
  return response.data;
};
export const blobToken = async (data) => {
  const response = await api.get(
    "/utility/blob/upload_token/token",
    {
      params: {
        uploadEnitityType: data.uploadEnitityType,
        uploadEntityId: data?.uploadEntityId,
      },
    },
    {
      requiresAuth: false,
    },
  );
  return response.data;
};

// Vendor Dashboard APIs
export const getVendorDashboardOverview = async () => {
  const response = await api.get("/vendor/dashboard/overview", {
    requiresAuth: true,
  });
  return response.data;
};

export const getVendorBookingTrend = async (year) => {
  const response = await api.get("/vendor/dashboard/booking-trend", {
    params: { year },
  });
  return response.data;
};

export const getVendorBookings = async ({
  page = 1,
  pageSize = 10,
  search = "",
  status = "All",
}) => {
  const response = await api.get("/vendor/bookings", {
    params: {
      currentPage: page,
      pageSize: pageSize,
      search: search || undefined,
      status: status === "All" ? undefined : status,
    },
  });
  return response.data;
};

// Vendor Analytics APIs
export const getVendorEarningsTrend = async ({ range, year }) => {
  const response = await api.get("/vendor/analytics/earnings-trend", {
    params: {
      range: range,
      year: range === "year" ? year : undefined,
    },
  });
  return response.data;
};

export const getVendorAnalyticsBookingTrend = async () => {
  const response = await api.get("/vendor/analytics/booking-trend");
  return response.data;
};

export const getVendorTopExperiences = async ({
  page = 1,
  pageSize = 6,
  search = "",
}) => {
  const response = await api.get("/vendor/analytics/top-experiences", {
    params: {
      currentPage: page,
      pageSize: pageSize,
      search: search || undefined,
    },
  });
  return response.data;
};

export const getVendorRecentReviews = async ({ page = 1, pageSize = 10 }) => {
  const response = await api.get("/vendor/analytics/recent-reviews", {
    params: {
      currentPage: page,
      pageSize: pageSize,
    },
  });
  return response.data;
};

// Vendor Payout APIs
export const getVendorPayoutsSummary = async () => {
  const response = await api.get("/vendor/payouts/summary");
  return response.data;
};

export const getVendorPayoutsEarnings = async ({
  page = 1,
  pageSize = 10,
  tab,
  dateFrom,
  dateTo,
  earningStatus,
  search,
}) => {
  const response = await api.get("/vendor/payouts/earnings", {
    params: {
      currentPage: page,
      pageSize: pageSize,
      tab: tab || undefined,
      dateFrom: dateFrom || undefined,
      dateTo: dateTo || undefined,
      earningStatus: earningStatus || undefined,
      search: search || undefined,
    },
  });
  return response.data;
};

// Vendor Experiences APIs
export const getVendorExperiences = async ({
  page = 1,
  pageSize = 10,
  status,
  category,
  search,
}) => {
  const response = await api.get("/vendor/experiences", {
    params: {
      currentPage: page,
      pageSize: pageSize,
      status: status === "All" ? undefined : status,
      categoryId: category || undefined,
      search: search || undefined,
    },
  });
  return response.data;
};

export const getVendorExperienceById = async (experienceId) => {
  const response = await api.get(`/vendor/experiences/${experienceId}`);
  return response.data;
};

export const createVendorExperience = async (data) => {
  const response = await api.post("/vendor/experiences", data);
  return response.data;
};

export const updateVendorExperience = async ({ experienceId, data }) => {
  const response = await api.put(`/vendor/experiences/${experienceId}`, data);
  return response.data;
};

export const vendorBookingComplete = async ({ bookingId }) => {
  const response = await api.patch(`/vendor/bookings/${bookingId}/complete`);
  return response.data;
};
export const vendorBookingConfirm = async ({ bookingId, data }) => {
  const response = await api.patch(`/vendor/bookings/${bookingId}/confirm`);
  return response.data;
};
export const vendorBookingSuggestedTime = async ({ bookingId, data }) => {
  const response = await api.patch(`/vendor/bookings/${bookingId}/confirm`);
  return response.data;
};
// Support Ticket APIs (used by all roles)
export const getSupportTickets = async ({
  page = 1,
  pageSize = 10,
  status,
  search,
  sort,
  role,
}) => {
  const response = await api.get(`/support/${role}/tickets`, {
    params: {
      currentPage: page,
      pageSize: pageSize,
      status: status === "All" ? undefined : status,
      search: search || undefined,
      sort: sort || undefined,
    },
  });
  return response.data;
};

export const createSupportTicket = async (data, role) => {
  const response = await api.post(`/support/${role}/tickets`, data);
  return response.data;
};

export const getSupportTicketById = async (ticketId, role) => {
  const response = await api.get(`/support/${role}/tickets/${ticketId}`);
  return response.data;
};

// Vendor Profile APIs
export const getVendorProfile = async () => {
  const response = await api.get("/vendor/profile");
  return response.data;
};

export const updateVendorProfile = async (data) => {
  const response = await api.put("/vendor/profile", data);
  return response.data;
};

// Stripe Payout APIs
export const getStripeStatus = async () => {
  const response = await api.get("/vendor/payouts/stripe/status");
  return response.data;
};

export const createStripeOnboardingLink = async () => {
  const response = await api.post(
    "/vendor/payouts/stripe/create-onboarding-link",
    {},
  );
  return response.data;
};

export const getStripeDashboardLink = async () => {
  const response = await api.get("/vendor/payouts/stripe/dashboard-link");
  return response.data;
};

export const getStripeUpdateLink = async () => {
  const response = await api.get("/vendor/payouts/stripe/update-link");
  return response.data;
};

export const getVendorBookingById = async (bookingId) => {
  const response = await api.get(`/vendor/bookings/${bookingId}`, {
    requiresAuth: true,
  });
  return response.data;
};

// Public APIs (User Homepage)
export const getPublicCategories = async () => {
  const response = await api.get("/categories");
  return response.data;
};

export const getPublicLocations = async () => {
  const response = await api.get("/locations");
  return response.data;
};

export const getPublicExperiences = async ({
  page = 1,
  pageSize = 10,
  isTop = false,
  search = "",
  categoryId,
  city,
  country,
  priceLowToHigh = false,
  priceHighToLow = false,
  duration,
  userId,
}) => {
  const response = await api.get("/public/experiences", {
    params: {
      currentPage: page,
      pageSize,
      isTop,
      search,
      categoryId,
      city,
      country,
      priceLowToHigh,
      priceHighToLow,
      duration,
      userId,
    },
  });

  return response.data;
};
export const getDurations = async () => {
  const response = await api.get("/durations");
  return response.data;
};

export const getPublicExperiencesByCategory = async ({
  categoryId,
  page = 1,
  pageSize = 10,
  search,
}) => {
  const response = await api.get(
    `/public/experiences/categories/${categoryId}`,
    {
      params: {
        currentPage: page,
        pageSize: pageSize,
        search,
      },
    },
  );
  return response.data;
};

export const getPublicExperiencesByLocation = async ({
  locationId,
  page = 1,
  pageSize = 10,
  search,
}) => {
  const response = await api.get(
    `/public/experiences/locations/${locationId}`,
    {
      params: {
        currentPage: page,
        pageSize: pageSize,
        search,
      },
    },
  );
  return response.data;
};

export const getPublicExperienceById = async (experienceId) => {
  const response = await api.get(`/public/experiences/${experienceId}`);
  return response.data;
};

// User Bookings API
export const getUserBookings = async ({
  page = 1,
  pageSize = 10,
  status,
  search,
}) => {
  const response = await api.get("/user/bookings", {
    params: {
      currentPage: page,
      pageSize: pageSize,
      status: status === "All" ? undefined : status,
      search: search || undefined,
    },
  });
  return response.data;
};

export const getUserBookingById = async (bookingId) => {
  const response = await api.get(`/user/bookings/${bookingId}`);
  return response.data;
};

// User Profile APIs
export const getUserProfile = async () => {
  const response = await api.get("/user/profile");
  return response.data;
};

export const updateUserProfile = async (data) => {
  const response = await api.put("/user/profile", data);
  return response.data;
};

export const addSupportTicketComment = async (ticketId, role, message) => {
  const response = await api.post(
    `/support/${role}/tickets/${ticketId}/comments`,
    { message },
  );
  return response.data;
};
// admin apis

export const getAdminDashboardSummary = async () => {
  const response = await api.get("/admin/dashboard/summary");
  return response.data;
};
export const getAdminDashboardVendorGrowth = async (year) => {
  const response = await api.get("/admin/dashboard/vendor-growth", {
    params: { year },
  });
  return response.data;
};
export const getAdminDashboardMonthlyBookings = async (year) => {
  const response = await api.get("/admin/dashboard/monthly-bookings", {
    params: { year },
  });
  return response.data;
};

export const getAdminVendorsList = async ({
  page = 1,
  pageSize = 10,
  status,
  search,
}) => {
  const response = await api.get("/admin/vendor", {
    params: {
      currentPage: page,
      pageSize,
      status: status === "All" ? undefined : status,
      search: search || undefined,
    },
  });
  return response.data;
};

export const getAdminVendorProfile = async (vendorId) => {
  const response = await api.get(`/admin/vendor/${vendorId}`);
  return response.data;
};

export const getAdminVendorApprove = async (vendorId) => {
  const response = await api.patch(`/admin/vendor/${vendorId}/approve`);
  return response.data;
};
export const getAdminVendorReject = async (vendorId, reason) => {
  const response = await api.patch(`/admin/vendor/${vendorId}/reject`, {
    reason,
  });
  return response.data;
};
export const getAdminVendorSuspend = async (vendorId, reason) => {
  const response = await api.patch(`/admin/vendor/${vendorId}/suspend`, {
    reason,
  });
  return response.data;
};
export const getAdminVendorActivate = async (vendorId) => {
  const response = await api.patch(`/admin/vendor/${vendorId}/activate`);
  return response.data;
};

export const getAdminVendorExperiences = async (
  vendorId,
  page,
  pageSize,
  search,
  status,
) => {
  const response = await api.get(`/admin/vendor/${vendorId}/experiences`, {
    params: {
      currentPage: page,
      pageSize: pageSize,
      search: search || undefined,
      status: status === "All" ? undefined : status,
    },
  });
  return response.data;
};

export const getAdminExperiences = async ({
  currentPage = 1,
  pageSize = 10,
  search,
  vendorId,
  status,
}) => {
  const response = await api.get("/admin/experiences", {
    params: {
      currentPage,
      pageSize,
      search: search || undefined,
      vendorId: vendorId || undefined,
      status: status || undefined,
    },
  });

  return response.data;
};

export const getAdminExperienceApprove = (experienceId) => {
  return api.patch(`/admin/experiences/${experienceId}/approve`);
};

// Reject
export const getAdminExperienceReject = ({ experienceId, reason }) => {
  return api.patch(`/admin/experiences/${experienceId}/reject`, { reason });
};

export const getAdminBookings = async ({
  page = 1,
  pageSize = 10,
  search,
  vendorId,
  status,
}) => {
  const response = await api.get("/admin/bookings", {
    params: {
      page,
      pageSize,
      search: search || undefined,
      vendorId: vendorId || undefined,
      status: status || undefined,
    },
  });

  return response.data;
};

export const getAdminSupportTickets = async ({
  page = 1,
  pageSize = 20,
  search,
  type,
  status,
  priority,
}) => {
  const response = await api.get("/support/admin/tickets", {
    params: {
      page,
      pageSize,
      search: search || undefined,
      type: type || undefined,
      status: status || undefined,
      priority: priority || undefined,
    },
  });

  return response.data;
};
export const getAdminPayouts = ({
  page = 1,
  pageSize = 20,
  search,
  status,
  fromDate,
  toDate,
}) => {
  return api.get("/admin/payouts", {
    params: {
      page,
      pageSize,
      search: search || undefined,
      status: status || undefined,
      fromDate: fromDate || undefined,
      toDate: toDate || undefined,
    },
  });
};

export const getAdminUsers = ({ page = 1, pageSize = 20, search, status }) => {
  return api.get("/admin/user", {
    params: {
      page,
      pageSize,
      search: search || undefined,
      status: status || undefined,
    },
  });
};

export const getAdminVendorById = async (vendorId) => {
  const response = await api.get(`/admin/vendor/${vendorId}`);
  return response.data;
};

export const getAdminExperienceById = (experienceId) => {
  return api.get(`/admin/experiences/${experienceId}`);
};

export const getAdminBookingById = async (bookingId) => {
  const response = await api.get(`/admin/bookings/${bookingId}`);
  return response.data;
};

export const getAdminVendorsDropdown = async () => {
  const response = await api.get("/admin/vendor/vendors/dropdown");
  return response.data;
};

export const stripeOnboarding = async () => {
  const response = await api.post(
    "/vendor/payouts/stripe/create-onboarding-link",
  );
  return response.data;
};

export const validateBooking = async (payload) => {
  const response = await api.post("/bookings/validate", payload);
  return response.data;
};

export const validateBookingGuest = async (payload) => {
  const response = await api.post("/bookings/guest/validate", payload);
  return response.data;
};

export const createCheckoutSession = async (payload) => {
  const response = await api.post("/payments/create-checkout-session", payload);
  return response.data;
};
export const createCheckoutSessionGuest = async (payload) => {
  const response = await api.post(
    "/payments/guest/create-checkout-session",
    payload,
  );
  return response.data;
};

export const vendorSuggestAlternateTime = async (data) => {
  const response = await api.post(
    "/vendor/bookings/suggest-alternateTime",
    data,
  );
  return response.data;
};

export const vendorBookingDeny = async ({ bookingId }) => {
  const response = await api.patch(`/vendor/bookings/${bookingId}/deny`);
  return response.data;
};

export const userAcceptAlternateTime = async ({ bookingId }) => {
  const response = await api.patch(
    `/user/bookings/accept-alternateTime/${bookingId}`,
  );
  return response.data;
};

export const userDenyAlternateTime = async ({ bookingId }) => {
  const response = await api.patch(
    `/user/bookings/deny-alternateTime/${bookingId}`,
  );
  return response.data;
};

export const userBookingsCompletion = async ({ bookingId }) => {
  const response = await api.patch(
    `/user/bookings/confirm-completion/${bookingId}`,
  );
  return response.data;
};

export const getPaymentSuccessDetails = async (tempBookingId) => {
  const response = await api.get(
    `/bookings/payment-success?tempBookingId=${tempBookingId}`,
  );
  return response.data;
};
export const getPaymentSuccessDetailsGuest = async (tempBookingId) => {
  const response = await api.get(
    `/bookings/payment-success/guest?tempBookingId=${tempBookingId}`,
  );
  return response.data;
};

export const changeSupportTicketStatus = async ({
  ticketId,
  status,
  comment,
}) => {
  const response = await api.patch(
    `/support/admin/tickets/${ticketId}/status`,
    {
      status,
      comment,
    },
  );

  return response.data;
};

export const getAdminUserProfile = async ({ userId }) => {
  const response = await api.get(`/admin/user/${userId}`);
  return response.data;
};

export const submitBookingReview = async ({ bookingId, rating, review }) => {
  const response = await api.post(`user/bookings/review/${bookingId}`, {
    rating,
    review,
  });
  return response.data;
};

export const firstFlightApply = async (data) => {
  const response = await api.post("/public/first-flight-fund/apply", data);
  return response.data;
};

export const getBookingCalendar = async (bookingId) => {
  const response = await api.get(`/bookings/calendar/${bookingId}`, {
    responseType: "text",
  });
  return response.data;
};
export const getVendorActiveAgreement = async () => {
  const response = await api.get(`/agreements/vendor/active`);
  return response.data;
};
export const getVendorAcceptAgreement = async (id) => {
  const response = await api.post(`/agreements/vendor/accept`, {
    agreementId: id,
  });
  return response.data;
};
export const getUserActiveAgreement = async () => {
  const response = await api.get(`/agreements/user/active`);
  return response.data;
};
export const getUserAcceptAgreement = async (id) => {
  const response = await api.post(`/agreements/user/accept`, {
    agreementId: id,
  });
  return response.data;
};

export const getUserBookingActiveAgreement = async () => {
  const response = await api.get(`/agreements/user/booking/active`);
  return response.data;
};

export const getPublicExperienceDetails = async (experienceSlug) => {
  const response = await api.get(
    `/public/experiencesDetails/${experienceSlug}`,
  );
  return response.data;
};

export const getPublicVendorProfile = async (vendorSlug) => {
  const response = await api.get(`/public/vendors/${vendorSlug}`);
  return response.data;
};

export const bookingCancel = async ({ bookingId }) => {
  const response = await api.patch(`/user/bookings/cancel/${bookingId}`);
  return response.data;
};
